if (!customElements.get('adev-stock-status')) {
    customElements.define('adev-stock-status', class adevStockStatus extends HTMLElement {
        constructor() {
            super();
        }

        refresh(variantId = null) {
            const variants = JSON.parse(this.querySelector('script').innerHTML);
            
            const inStockText = this.getAttribute('data-in-stock-text') || 'In Stock';
            const lowStockText = this.getAttribute('data-low-stock-text') || 'Limited Stock';
            const outOfStockText = this.getAttribute('data-out-of-stock-text') || 'Out of Stock';
            

            if (variantId) {
                this.setAttribute('data-current-variant-id', variantId);
            }

            const currentVariantId = this.getAttribute('data-current-variant-id');

            const threshold = parseInt(this.getAttribute('data-low-stock-threshold')) || 10;
            let currentVariant = variants.find(variant => variant.id == currentVariantId);
            
            let status = 'in_stock';

            if (currentVariant.available) {
                status = 'in_stock';
            } else {
				if (currentVariant.inventory > threshold) {
                    status = 'in_stock';
				} else if (currentVariant.inventory > 0 && currentVariant.inventory <= threshold) {
					status = 'low_stock';
				} else {
					status = 'out_of_stock';
				}
            }

            this.setAttribute('data-status', status);
            this.querySelector('[data-adev-stock-status="text"]').innerText = 
                status === 'in_stock' ? inStockText :
                status === 'low_stock' ? lowStockText :
                outOfStockText;
        }

        connectedCallback() {
            this.refresh();
            
            document.addEventListener('adev:variant-change', (event) => {
                const variantId = event.detail.variantId;
                this.refresh(variantId);
            });
        }

    });
}